module.exports = __webpack_public_path__ + "static/quartier_L-b5a508c2bb986cc16bf9af5a6790c7b3.png";